import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsBusinessTabCacheKeys } from "./constants";
import type { PostCustomObjectsBatchLinkUserParams, PostCustomObjectsBatchLinkUserResponse } from "./types";

export const postCustomObjectsBatchLinkUser = reactQueryMutationAdapter(
  customObjectsBusinessTabCacheKeys,
  ({
    typeName,
    userId,
    relKind,
    objects,
  }: PostCustomObjectsBatchLinkUserParams): Promise<PostCustomObjectsBatchLinkUserResponse> => {
    return fetch<PostCustomObjectsBatchLinkUserResponse>(
      `/custom_objects/${encodeURIComponent(typeName)}/users/${encodeURIComponent(userId)}/batch_link`,
      "POST",
      { rel_kind: relKind, objects },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
